
import * as React from 'react';
import { ListItemIcon, Menu, MenuItem, Typography } from '@mui/material';
import { FaEllipsisV } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import {
  clearState,
} from "../../../store/slices/customerListSlice";
import { formatCurrency, formatDate } from "../../../lib/helpers";
import commonNetwork from '../../../common/api/commonNetwork';
import { toast } from 'react-toastify';
import UpdateRowModal from "./UpdateRowModal";
import PaymentDetails from "./PaymentDetails";
import BottomButtons from "./BottomButtons";
import MaterailTable from '../Elements/MaterialTable';
import { controlPaymentLinkPackages } from '../../../common/helpers/packagesHelper';
import PackageErrorModal from '../PackageErrorModal';
import PaymentLinkResultModal from '../PaymentLinkResultModal';
import ErrorIcon from '@mui/icons-material/Error';
import { linkStatus } from '../../../constants/linkstatusField';
import { getCurrencyDesc } from '../../../common/helpers/exchangeFields';
import { isValidEmailAddress, isValidPhoneNumber } from '../../../common/helpers/globalHelpers';
import HtmlTooltip from '../HtmlTooltilp';
import StatusBox from '../Elements/StatusBox';
import { Edit } from '@mui/icons-material';
import { getLinkParameters } from '../../../store/slices/linkParametersSlice';
import appHelpers from '../../../common/helpers/appHelpers';
import { sendTypeIds } from '../../../constants/options/sendOptions';






export default function CustomersTable() {

  const {
    customers,
    isSuccess,
    isFetching,
    isError,
    totalRecords,
    isfetchComplete,
    selectedAmountType
    // currentPage,
  } = useSelector((state) => state.customerlist);
  const isDemoUser = appHelpers.isDemoUser();

  const { defaultSendTypeId, linkExpiryDate } = useSelector((state) => state.linkParameters);

  const updateCustomerRowRef = React.useRef();
  const reportTableRef = React.useRef();
  const linResultModalRef = React.useRef();

  const [dropdownMenuId, setDropdownMenuId] = React.useState("");
  const [isPackageErrorModalVisible, setIsPackageErrorModalVisible] = React.useState(false);
  const [postLinkLoading, setPostLinkLoading] = React.useState(false);
  const [statusModalVisible, setStatusModalVisible] = React.useState(false);
  const [packageErrorMessage, setPackageErrorMessage] = React.useState("");

  const [paymentDetailInfo, setPaymentDetailsInfo] = React.useState({
    installments: [],
    vpId: 0,
    paymentType: "dynamic",
    lastlinkdate: linkExpiryDate,
    sendtype: defaultSendTypeId,
    linkdesc: "",
    isEditableAmount: false,
    isDisableCommission : false
  });



  const dispatch = useDispatch();


  React.useLayoutEffect(() => {

    dispatch(getLinkParameters({}));
    dispatch(clearState({}));
  }, [])




  const [anchorEl, setAnchorEl] = React.useState(null);
  const isopenMenu = Boolean(anchorEl);
  const handleClickMenu = (event, customerCode) => {

    setDropdownMenuId(customerCode);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };


  const updateRowClick = (customercode) => {



    const index = customers.findIndex(w => w.customercode == customercode);
    const row = customers[index];

    setAnchorEl(null);
    updateCustomerRowRef.current.openModal(row);
  }

  const onSubmitForm = async () => {

    if (isDemoUser) {
      toast.error("Demo kullanımında sadece Serbest Ödeme Süreci üzerinden ödeme linki oluşturabilirsiniz.");

      return;
    }


    var selecteds = reportTableRef.current.getSelectedRows();

    const formData = [];
    customers.forEach((customer) => {
      if (selecteds.indexOf(customer.erpCustomerId) != -1) {

        var customerName = customer.customername;


        let installments = "";
        if (paymentDetailInfo.installments) {
          paymentDetailInfo.installments.map((installment) => {
            if (installments !== "") installments += ",";
            installments += installment;
          });
        }
        var desc = paymentDetailInfo.linkdesc;
        if (customer.linkdesc) {
          desc = customer.linkdesc;
        }
        var requestAmount = formatCurrency(customer.requestamount);

        formData.push({
          CUSTOMERNAME: customerName,
          CUSTOMERCODE: customer.customercode,
          TAXCODE: customer.vkntckn || customer.taxnumber,
          AMOUNT: requestAmount.toString().replaceAll(",", "").replace(".", ""),
          SENDTYPEID: paymentDetailInfo.sendtype || 3,
          EMAIL: customer.email,
          PHONE: customer.phone
            ?.replace("(", "")
            .replace(")", "")
            .replace(/\s+/g, ""),
          LINKDESC: desc,
          VPID: paymentDetailInfo.vpId,
          EXPIREDATE: formatDate(customer.expiredate),
          EXPIREDATETYPE: paymentDetailInfo.lastlinkdate,
          INSTALLMENTS: installments,
          ISEDITAMOUNT: paymentDetailInfo.isEditableAmount,
          ISCOMMISSION : paymentDetailInfo.isDisableCommission ==true ? false: true,
          DAY : parseInt((customer.gun ||0))
        });
      }
    });

    if (selecteds.length > 0) {
      setPostLinkLoading(true);


      await controlPackages(formData);




    } else {
      toast.error("Lütfen bir kayıt seçiniz");
    }
  };
  const controlPackages = async (formData) => {
    var emailCount = 0, smsCount = 0, whatsappCount = 0;

    for (let i = 0; i < formData.length; i++) {
      const element = formData[i];
      if (element.SENDTYPEID == sendTypeIds.sms || element.SENDTYPEID == sendTypeIds.emailAndSms) { // sms
        smsCount++;
      }
      if (element.SENDTYPEID == sendTypeIds.email || element.SENDTYPEID == sendTypeIds.emailAndSms) { // sms
        emailCount++;
      }
      if (element.SENDTYPEID == sendTypeIds.whatsapp) {
        whatsappCount++;
      }
    }

    const packageResult = await controlPaymentLinkPackages(smsCount, emailCount, whatsappCount);

    if (packageResult.serviceError != true) {

      const { isMailOverflow, isSmsOverflow, mailOverflowCount, smsOverflowCount, isWhatsappOverflow } = packageResult;
      if (isMailOverflow || isSmsOverflow || isWhatsappOverflow) {
        setPostLinkLoading(false);
        setIsPackageErrorModalVisible(true);
      } else {
        postPaymentLinksAfterControl(formData);
      }


    } else {
      setPostLinkLoading(false);
      toast.error(packageResult.errorMessage);
    }
  } 

  const postPaymentLinksAfterControl = async (formData) => {

    const response = await commonNetwork.post("/payment-link-batch", formData);

    setPostLinkLoading(false);
    const { isSuccess, data, errorMessage } = response;

    if (isSuccess) {
      reportTableRef.current.clearSelected();

      var successList = [], errorList = [];
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        if (!element.smsstatus || !element.mailstatus || !element.success) {
          errorList.push({
            ...element,
          });
        } else {

          successList.push({
            ...element
          });
        }
      }


      setStatusModalVisible(true);
      linResultModalRef.current.showMessage(errorList, successList);
      if (errorList.length == 0) {
        dispatch(clearState());
      }
    } else {
      toast.error(errorMessage);
    }

  }


  const DropdownMenu = () => {

    return (
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={isopenMenu}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={() => {
          updateRowClick(dropdownMenuId)
        }}>
          <ListItemIcon>
            <Edit fontSize="small" />
          </ListItemIcon>
          Güncelle
        </MenuItem>
      </Menu>
    );
  }


  const getRowError = (row) => {



    var mailErrorMessage = "", smsErrorMessage = "";
    var mailStatus = isValidEmailAddress(row.email);
    var phoneStatus = isValidPhoneNumber(row.phone);

    if ((paymentDetailInfo.sendtype == 3 || paymentDetailInfo.sendtype == 2) && !mailStatus) {
      if (row.email) {
        mailErrorMessage = "Lütfen Email adresini doğru formatta giriniz.";
      } else {
        mailErrorMessage = "Lütfen Email adresini giriniz.";
      }
    }
    if ((paymentDetailInfo.sendtype == 3 || paymentDetailInfo.sendtype == 1) && !phoneStatus) {
      if (row.phone) {
        smsErrorMessage = "Lütfen Telefon numarasını doğru formatta giriniz.";
      } else {
        smsErrorMessage = "Lütfen Telefon numarasını giriniz.";
      }
    }
    if (mailErrorMessage.length > 0 || smsErrorMessage.length > 0) {
      return (
        <HtmlTooltip
          title={
            <React.Fragment>
              <Typography color="inherit">Uyarı!</Typography>
              {mailErrorMessage}
              {mailErrorMessage ? (
                <br />
              ) : null}
              {smsErrorMessage}
            </React.Fragment>
          }
        >
          <ErrorIcon className='text-error-text' />
        </HtmlTooltip>
      );
    }
  }

  function getLinkStatusInfo(status) {


    if (status === linkStatus.successComplete) {
      return <StatusBox content="Ödeme Başarılı" statusType="success" />;
    }
    if (status == linkStatus.waitOrder) {
      return <StatusBox content="Link Oluşturuldu" statusType="primary" />;
    }
    if (status === linkStatus.expire) {
      return <StatusBox content="Süresi Doldu" statusType="error" />;
    }
    return null;
  }


  var exchangeRows = [
    {
      id: 'amountlist',
      numeric: true,
      disablePadding: false,
      label: 'Dövizli Borç',
      className: "min-w-[120px]",
      isMoney: true,
      disableFormat: true,
      maxLength: 15,
      isRender: true,
      renderRow: (row) => {
        var amountList = row.amountList || [];
        if (amountList.length > 0) {
          return amountList.map((item, index) => (
            <div style={{
              textAlign: "center"
            }}>
              {formatCurrency(item)}
            </div>
          ));
        }
        else return null;
      }
    },
    {
      id: 'foreigncurrencytype',
      numeric: true,
      disablePadding: false,
      label: 'Döviz Türü',
      className: "min-w-[110px]",
      isRender: true,
      renderRow: (row) => {

        var currencyList = row.currencyList || [];
        if (currencyList.length > 0) {
          return currencyList.map((item, index) => (
            <div style={{
              textAlign: "center"
            }}>
              {getCurrencyDesc(item)}
            </div>
          ));
        } 
      }
    }
  ];
  var amountDay=[];

  if (selectedAmountType == 2) {
    exchangeRows=[];
    amountDay=[ {
      id: 'gun',
      numeric: false,
      disablePadding: true,
      label: 'Gecikme Günü',
      isprimary: false,
      hide: false
    }];
  }
  const headCells = [
    {
      id: 'operations',
      numeric: false,
      label: 'İşlemler',
      disablePadding: true,
      exceptToExcel: true,
      isRender: true,
      renderRow: (row) => {

        return (
          <div className='flex flex-row justify-around'>
            <a id="basic-button"
              style={{
                display: "flex",
                alignItems: "center"
              }}
              aria-controls={isopenMenu ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={isopenMenu ? 'true' : undefined}
              className="cursor-pointer"
              onClick={(event) => handleClickMenu(event, row.customercode)}>
              <FaEllipsisV
                className="block sm:block ml-2 h-3 w-3 font-light "
                aria-hidden="true"
              />
            </a>
            <DropdownMenu row={row}>

            </DropdownMenu>
            <div style={{
              width: 24
            }}>
              {getRowError(row)}
            </div>
          </div>
        );

      }
    },
    {
      id: 'erpCustomerId',
      numeric: false,
      disablePadding: true,
      label: 'ID',
      isprimary: true,
      hide: true
    },
    {
      id: 'customercode',
      numeric: true,
      disablePadding: false,
      label: 'Cari Hesap Kodu',
      className: "min-w-[150px]",
      maxLength: 20
    },
    {
      id: 'customername',
      numeric: true,
      disablePadding: false,
      label: 'Cari Hesap Ünvan',
      className: "min-w-[360px]",
      maxLength: 50,

    },
    {
      id: 'taxnumber',
      numeric: true,
      disablePadding: false,
      label: 'Cari Hesap VKN/TCKN',
      className: "min-w-[180px]",
      maxLength: 11,
      isRender: true,
      renderRow: (row) => {

        return (
          <div  >
            {row.taxnumber || row.vkntckn}
          </div>
        );
      }
    },
    {
      id: 'amount',
      numeric: true,
      disablePadding: false,
      label: selectedAmountType == 2?"Vadesi Geçmiş Borç Bakiyesi":  'Borç Bakiyesi',
      className: "min-w-[125px]",
      isMoney: true,
      maxLength: 15
    },
    ...exchangeRows,
    ...amountDay,
    {
      id: 'requestamount',
      numeric: true,
      disablePadding: false,
      label: 'Ödeme Talebi Bakiyesi',
      className: "min-w-[140px]",
      isMoney: true,
      maxLength: 15
    },
    {
      id: 'phone',
      numeric: true,
      disablePadding: false,
      label: 'Telefon',
      className: "min-w-[110px]",
      maxLength: 15
    },

    {
      id: 'email',
      numeric: true,
      disablePadding: false,
      label: 'Email',
      className: "max-w-[220px]",
      maxLength: 30
    },
    {
      id: 'linkstatus',
      numeric: true,
      disablePadding: false,
      label: 'Link Durumu',
      className: "min-w-[150px]",
      isRender: true,
      renderRow: (row) => {
        return getLinkStatusInfo(row.linkstatus)

      }
    }
  ];

  const bottomElement = <BottomButtons onSubmitForm={onSubmitForm} loadingVisible={postLinkLoading} />



  return (
    <>


      <PaymentDetails
        showParameters={customers.length > 0}
        paymentType={"dynamic"}
        vpId={0}
        paymentDetailInfo={paymentDetailInfo}
        setPaymentDetailsInfo={setPaymentDetailsInfo}
      />
      <MaterailTable ref={reportTableRef} headerCells={headCells} tableData={customers} isRowSelect bottomElement={bottomElement} isLoading={isFetching} emptyMessage={isfetchComplete ? "Verilen kritere uygun cari kayıt bulunamamıştır" : ""}></MaterailTable>


      <UpdateRowModal ref={updateCustomerRowRef} ></UpdateRowModal>

      <PackageErrorModal errorMessage={packageErrorMessage} isVisible={isPackageErrorModalVisible} setIsVisible={setIsPackageErrorModalVisible}></PackageErrorModal>

      <PaymentLinkResultModal ref={linResultModalRef} statusModalVisible={statusModalVisible} setStatusModalVisible={setStatusModalVisible}></PaymentLinkResultModal>
    </>
  );
}
